import _ from 'lodash';
import { DEFAULT_TABLE_COLUMN_PROPERTIES, } from '../client-state-type';
import { BackgroundFormatTypes, ConditionalFormattingComparisonTypes, Operators, } from '../types/prism';
export function isValidConditionalMetricRow(row) {
    const isGradient = row.backgroundFormatType === BackgroundFormatTypes.Gradient;
    if (!isGradient && _.isNil(row.operator)) {
        return false;
    }
    if (row.operator === Operators.IsBetween && _.isNil(row.rangeValues)) {
        return false;
    }
    if (!isGradient) {
        const isValueBasedComparison = _.isNil(row.comparisonType) ||
            row.comparisonType ===
                ConditionalFormattingComparisonTypes.ValueBased;
        const isValuelessOperator = [
            Operators.IsNull,
            Operators.IsNotNull,
            Operators.IsEmpty,
            Operators.IsNotEmpty,
            Operators.IsBetween,
        ].includes(row.operator);
        if (isValueBasedComparison &&
            !isValuelessOperator &&
            _.isNil(row.value)) {
            return false;
        }
    }
    if (row.comparisonType ===
        ConditionalFormattingComparisonTypes.ColumnBased &&
        _.isNil(row.rhsColumnId)) {
        return false;
    }
    if (row.comparisonType ===
        ConditionalFormattingComparisonTypes.ParameterBased &&
        _.isNil(row.comparisonParameterId)) {
        return false;
    }
    if (isGradient && _.isNil(row.gradientBackgroundAttrs)) {
        return false;
    }
    if (row.backgroundFormatType === BackgroundFormatTypes.Solid &&
        _.isNil(row.solidBackgroundAttrs)) {
        return false;
    }
    return true;
}
export function getValidConditionalFormatting(conditionalFormatting, validColumnIds) {
    if (_.isNil(conditionalFormatting) || _.isNil(conditionalFormatting.rows)) {
        return null;
    }
    const validRows = conditionalFormatting.rows.filter(row => {
        if (_.isNil(row === null || row === void 0 ? void 0 : row.lhsColumnId) ||
            !validColumnIds.includes(row.lhsColumnId)) {
            return false;
        }
        if (!_.isNil(row.rhsColumnId) &&
            !validColumnIds.includes(row.rhsColumnId)) {
            return false;
        }
        return isValidConditionalMetricRow(row);
    });
    if (validRows.length === 0 && conditionalFormatting.rows.length > 0) {
        return null;
    }
    return {
        ...conditionalFormatting,
        rows: validRows,
    };
}
function applyTableDisplayOverrides(tableVizProps, displayProperties) {
    if (_.isNil(displayProperties)) {
        return tableVizProps;
    }
    const updatedTableVizProps = { ...tableVizProps };
    if (!_.isNil(displayProperties.tableTheme)) {
        updatedTableVizProps.theme = displayProperties.tableTheme;
    }
    if (!_.isNil(displayProperties.tableContentDensity)) {
        updatedTableVizProps.density = displayProperties.tableContentDensity;
    }
    return updatedTableVizProps;
}
function applyTableColumnOverrides(tableVizProps, columnPropertyOverrides, columns) {
    var _a;
    if (_.isNil(columnPropertyOverrides)) {
        return tableVizProps;
    }
    const validColumnIds = columns.map(col => col.column.id);
    const validColumnPropertyOverrides = columnPropertyOverrides.filter(cp => !_.isNil(cp === null || cp === void 0 ? void 0 : cp.columnId) &&
        validColumnIds.includes(cp.columnId) &&
        !_.isNil(cp.columnProperty));
    const updatedColumnProperties = _.cloneDeep((_a = tableVizProps.columnProperties) !== null && _a !== void 0 ? _a : []);
    validColumnPropertyOverrides.forEach(columnPropertyOverride => {
        var _a, _b;
        const existingPropIndex = updatedColumnProperties.findIndex(cp => (cp === null || cp === void 0 ? void 0 : cp.columnId) === columnPropertyOverride.columnId);
        const validConditionalFormatting = getValidConditionalFormatting((_a = columnPropertyOverride.columnProperty) === null || _a === void 0 ? void 0 : _a.conditionalFormatting, validColumnIds);
        const overrideProperty = columnPropertyOverride.columnProperty;
        const applicableOverrides = _.pickBy({
            isHidden: overrideProperty.isHidden,
            wrapColumnText: overrideProperty.wrapColumnText,
            conditionalFormatting: validConditionalFormatting,
        }, v => !_.isNil(v));
        if (existingPropIndex >= 0) {
            updatedColumnProperties[existingPropIndex].columnProperty = {
                ...DEFAULT_TABLE_COLUMN_PROPERTIES,
                ...(_b = updatedColumnProperties[existingPropIndex]) === null || _b === void 0 ? void 0 : _b.columnProperty,
                ...applicableOverrides,
            };
        }
        else {
            updatedColumnProperties.push({
                __typename: 'TableColumnPropertyMap',
                columnId: columnPropertyOverride.columnId,
                columnProperty: {
                    ...DEFAULT_TABLE_COLUMN_PROPERTIES,
                    ...applicableOverrides,
                },
            });
        }
    });
    return {
        ...tableVizProps,
        columnProperties: updatedColumnProperties,
    };
}
export function applyTableVisualOverrides(vizModel, columns) {
    const vizProps = vizModel.vizProps;
    const visualOverrides = vizModel.visualOverrides;
    if (_.isNil(visualOverrides) || _.isNil(visualOverrides.overrides)) {
        return vizProps;
    }
    const { displayProperties, columnProperties: columnPropertyOverrides, } = visualOverrides.overrides;
    let updatedTableVizProps = _.cloneDeep(vizProps);
    updatedTableVizProps = applyTableDisplayOverrides(updatedTableVizProps, displayProperties);
    updatedTableVizProps = applyTableColumnOverrides(updatedTableVizProps, columnPropertyOverrides, columns);
    return updatedTableVizProps;
}
//# sourceMappingURL=table-overrides-util.js.map